import { useState } from 'react'
import { useStudioSignalsLazy } from 'Studio/signals/useStudioSignalsLazy'
import { StudioSystemType } from 'types/global'
import { isExistingSystem } from './utils'

export const getExistingSystem = (systems: StudioSystemType[] | undefined): StudioSystemType | undefined => {
  return systems?.find((system) => isExistingSystem(system))
}

const useExistingSystem = () => {
  const [existingSystem, setExistingSystem] = useState(getExistingSystem(window.editor?.getSystems()))
  const checkIsRetrofitProject = (object) => {
    if (object.type !== 'OsSystem') {
      return
    }
    setExistingSystem(getExistingSystem(window.editor?.getSystems()))
  }

  useStudioSignalsLazy(checkIsRetrofitProject, ['objectChanged', 'objectAdded', 'objectRemoved'], undefined, {
    trackHandler: true,
  })

  return existingSystem
}

export default useExistingSystem
